import { useAuth } from "@/contexts/AuthContext"
import { useLanguage } from "@/hooks/use-language"
import { ThemeToggle } from "@/components/ThemeToggle"
import { Zap, Wallet } from "lucide-react"

export function Login() {
  const { login } = useAuth()
  const { language } = useLanguage()

  return (
    <div className="min-h-screen bg-background">
      <div className="fixed top-4 right-4 z-50">
        <ThemeToggle />
      </div>

      <div className="container-internal">
        <div className="flex items-center justify-center mb-4">
          <div className="w-16 h-16 bg-primary rounded-lg flex items-center justify-center">
            <Zap className="w-9 h-9 text-primary-foreground" />
          </div>
        </div>

        <div className="login-container">
          <div className="login-form">
            <h1 className="login-title">
              {language === "en" ? "Sign In" : "Iniciar Sesión"}
            </h1>
            <p className="login-subtitle">
              {language === "en"
                ? "Access your trading signals dashboard"
                : "Accede a tu panel de señales de trading"}
            </p>

            <div className="space-y-3 mt-6">
              <button
                type="button"
                onClick={login}
                className="w-full login-btn flex items-center justify-center gap-2.5"
              >
                <Wallet className="w-5 h-5" />
                {language === "en" ? "Connect Wallet" : "Conectar Wallet"}
              </button>

              <button
                type="button"
                onClick={login}
                className="w-full max-w-full bg-white text-gray-900 hover:bg-gray-50 border border-gray-300 rounded-lg px-4 py-3 flex items-center justify-center gap-2.5 text-sm font-medium transition-all duration-200 shadow-sm hover:shadow-md"
                style={{ backgroundColor: '#FFFFFF', color: '#111827' }}
              >
                <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
                <span style={{ color: '#111827', fontWeight: 500 }}>
                  {language === "en" ? "Continue with Google" : "Continuar con Google"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
